import { render } from "./HumanReadableTime.vue?vue&type=template&id=2a26f070"
import script from "./HumanReadableTime.vue?vue&type=script&lang=js"
export * from "./HumanReadableTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__